/**
 * In order to be able to use groupName as an anchor we need to make it a connected string
 * to prevent other symbols appear if the name has spaces.
 * Example: 'Energielabel & Duurzaamheidsadvies' will be 'Energielabel_&_Duurzaamheidsadvies', and not 'Energielabel%20&%20Duurzaamheidsadvies'
 */

const groupNameToAnchorId = (name: string): string => name.split(' ').join('_');

export default groupNameToAnchorId;
